module.exports = __webpack_public_path__ + "static/petropolis-dbbb09376b350ecaf381abfdcf6b4d44.jpg";